"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _getMenuItems = _interopRequireDefault(require("../menuItems/getMenuItems"));
var _menuItemsPropTypes = _interopRequireDefault(require("./menuItemsPropTypes"));
var _MenuItems = _interopRequireDefault(require("../menuItems/MenuItems"));
var _excluded = ["title", "items", "disabled", "className"];
var DropdownSubmenu = function DropdownSubmenu(props) {
  var title = props.title,
    items = props.items,
    disabled = props.disabled,
    className = props.className,
    remainingProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var classes = (0, _classnames["default"])('dropdown-submenu', disabled && 'disabled', className && className);
  return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({}, remainingProps, {
    className: classes
  }), /*#__PURE__*/_react["default"].createElement("a", {
    className: "submenu-title"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "submenu-title-text"
  }, title), /*#__PURE__*/_react["default"].createElement("span", {
    className: "rioglyph rioglyph-menu-right"
  })), /*#__PURE__*/_react["default"].createElement(_MenuItems["default"], null, (0, _getMenuItems["default"])(items)));
};
DropdownSubmenu.defaultProps = {
  title: '',
  items: [],
  disabled: false
};
DropdownSubmenu.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  items: _menuItemsPropTypes["default"],
  disabled: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var _default = DropdownSubmenu;
exports["default"] = _default;